/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";
import { useBetween } from "use-between";
import { useAuthApi, useCartApi, useCatalogApi } from "../../pages/useApi";

import "./index.scss";
import CartItem from "./item";
import AwareButton from "../button";
import { toTwoDecimals } from "../../plugins";
import CartTimer from "../cart-timer";
import { useNavigate } from "react-router-dom";
import { Button, Image, Spinner } from "react-bootstrap";
import { toast } from "react-toastify";
import SimilarProductsModal from "../../pages/order/SimilarProductsModal";
import OutOfStockProductsModal from "../../pages/order/OutOfStockProductsModal";
import GiftBoxIcon from "../../assets/images/gift/giftBoxIcon.svg";
import SuccessModal from "../../pages/order/SuccessModal";
import CartExpiredAlertModal from "./CartExpiredAlertModal";
import NotFoundIcon from "./../../assets/images/profile/404.svg";

const convertIntoNumber = (cartSessionTime) => {
    const actualReserveTime = 60 * 30;
    const sessionMs = new Date(cartSessionTime).getTime();
    const timeDiff = Math.floor((Date.now() - sessionMs) / 1000);
    return actualReserveTime - timeDiff > 0
        ? actualReserveTime - timeDiff
        : 0;
};

const Cart = ({ status, setStatus, currentPage, handlePlaceOrders }) => {
    const [cartTimeExpired, setCartTimeExpired] = useState(false);
    const [showSuccessModal, setShowSuccessModal] = useState(false);
    const [showProductsModal, setShowProductsModal] = useState(false);
    const [showSimilarProductsModal, setShowSimilarProductsModal] = useState(
        false
    );
    const [unavailableProducts, setUnavailableProducts] = useState([]);
    const [similarProducts, setSimilarProducts] = useState([]);
    const [findSimilarProductId, setFindSimilarProductId] = useState("");
    const {
        cart,
        setCart,
        cartTime,
        setCartTime,
        getCart,
        totalPrice,
        originalPrice,
        linePricingByProductId,
        cartOpen,
        setCartOpen,
        reviewOrder,
        setShowGamificationPopOver,
        productByBatch,
        ordering
    } = useBetween(useCartApi);
    const { customerId, multipleCustomers, rewards, rewardsThreshold, customerRewardItem } = useBetween(useAuthApi);
    const { updating } = useBetween(useCatalogApi);
    const navigate = useNavigate();

    const handleReviewOrders = () => {
        if (cart.products.length > 0) {
            navigate(`/checkout`);
        } else {
            toast.error("Please add products before proceeding.");
        }
    };

    useEffect(() => {
        if (customerId) {
            getCart(customerId).then((response) => {
                if (!response.cart.SessionTime) {
                    handleRebuildCart();
                }
            });
        }
    }, [customerId]);

    const branchPriceTotals = {};

    if (productByBatch) {
        for (const [branchName, products] of Object.entries(productByBatch)) {
            const total = products.reduce((sum, product) => {
                const productId = String(product?.InventoryID?.value ?? "");
                const linePricing = linePricingByProductId?.[productId];
                if (linePricing) return sum + Number(linePricing.lineTotal || 0);

                const cartProduct = cart.products.find(p => p.productId === productId);
                const quantity = cartProduct?.quantity;
                const productPrice = product.DefaultPrice?.value;
                const price = (quantity && productPrice) ? (quantity * productPrice) : 0;
                return sum + Number(price);
            }, 0);

            branchPriceTotals[branchName] = Number.isNaN(total) ? 0 : total;
        }
    }

    const removeProduct = (productId) => {
        const productIndex = unavailableProducts.findIndex(
            (product) => product.id === productId
        );
        unavailableProducts.splice(productIndex, 1);
        setUnavailableProducts([...unavailableProducts]);
    };

    const handleNavigation = () => {
        navigate(`/collection/all`);
        setCartOpen(!cartOpen);
    };

    const handleRebuildCart = () => {
        reviewOrder()
            .then((response) => {
                cart.products = response.availableProduct;
                if (response.unavailableProducts.length > 0) {
                    setUnavailableProducts(response.unavailableProducts);
                    setShowProductsModal(true);
                } else {
                    setShowSuccessModal(true);
                }
                setCart(cart);
                setCartTimeExpired(false);
                setCartTime(convertIntoNumber(response.SessionTime));
            })
            .catch((err) => {
                console.log("handleRebuildCart error", err);
            });
    };


    return (
        <div className={`cart-drawer ${status ? "active" : ""}`}>
            <div
                className={`cart-wrapper ${multipleCustomers ? "hasMultipleCustomers" : ""
                    }`}
            >
                <div className='mobile-menu-header d-flex d-md-none justify-content-between align-items-center'>
                    <h3>Cart</h3>
                    {/* <XIcon
                        className='cursor-pointer'
                        width='24'
                        height='24'
                        onClick={() => setStatus(false)}
                    /> */}
                </div>
                <div className='cart-drawer-header'>
                    <div className='d-flex justify-content-between align-items-center'>
                        <h4>Order Summary</h4>
                        <Button
                            variant='link'
                            size='sm'
                            className='btn-close'
                            aria-label='Remove'
                            onClick={() => setStatus(false)}
                        ></Button>
                    </div>
                    {Object.keys(cart).length > 0 &&
                        cart.products.length > 0 && (
                            <CartTimer
                                showTimeOnly={false}
                                rebuildCart={handleRebuildCart}
                                setCartTimeExpired={setCartTimeExpired}
                            />
                        )}
                </div>
                <div
                    className={`items-container ${(cartTime <= 0 || cartTimeExpired) &&
                        Object.keys(cart).length > 0 &&
                        cart.products.length > 0
                        ? "cart-time-expired"
                        : ""
                        }`}
                >
                    {Object.keys(cart).length > 0 &&
                        cart.products.length > 0 ? (
                        Object.entries(productByBatch).map(([key, value]) => (
                            <div key={key}>

                                <h6 style={{ padding: '15px 20px', fontSize: '14px' }}>{key}</h6>

                                {
                                    value.map((item) => (
                                        <CartItem key={String(item.InventoryID?.value)} item={item} />
                                    ))
                                }
                            </div>


                        ))
                    ) : (
                        <div
                            className='empty-cart-block text-center h-100 d-flex align-items-center justify-content-center'>
                            <div>
                                <Image
                                    src={NotFoundIcon}
                                    className='mb-2'
                                    alt='404 icon'
                                />
                                <p className='py-3 px-2 no-items-text'>
                                    Your cart is empty
                                </p>
                                <AwareButton
                                    href={`/collection/all`}
                                    className='btn btn-green btn-lg btn-rebuild'
                                >
                                    Start Shopping
                                </AwareButton>
                            </div>
                        </div>
                    )}
                </div>
                <div
                    className={`order-btn-container ${(cartTime <= 0 || cartTimeExpired) &&
                        Object.keys(cart).length > 0 &&
                        cart.products.length > 0
                        ? "cart-time-expired"
                        : ""
                        }`}
                >
                    {rewards.length > 0 && rewardsThreshold && (
                        <div className='gift-item-wrapper'>
                            <div className='d-flex align-items-center'>
                                <Image src={GiftBoxIcon} />
                                {totalPrice < rewardsThreshold.threshold1 ? (
                                    <div>{`Add $${toTwoDecimals(
                                        rewardsThreshold.threshold1 - totalPrice
                                    )} to unlock a reward.`}</div>
                                ) : customerRewardItem ? (
                                    <div>
                                        {`Free ${customerRewardItem.ItemName.value}. `}
                                        <span
                                            className='text-link'
                                            onClick={() =>
                                                setShowGamificationPopOver(true)
                                            }
                                        >
                                            Change
                                        </span>
                                    </div>
                                ) : (
                                    <div
                                        className='text-link'
                                        onClick={() =>
                                            setShowGamificationPopOver(true)
                                        }
                                    >{`Select free gift`}</div>
                                )}
                            </div>
                        </div>
                    )}
                    {Object.entries(branchPriceTotals).map(([branchName, totalPrice]) => (
                        <div key={branchName} className="p-2">
                            <div className="d-inline-flex align-items-right">
                                <label className="me-3">{branchName} Total:</label>
                                <p >
                                    {totalPrice > 0 && `$${toTwoDecimals(totalPrice)}`}
                                </p>
                            </div>
                        </div>
                    ))}
                    <div className='action-button-wrapper'>
                        <div className='total-price d-inline-flex'>
                            <label className='me-3'>Total:</label>
                            <p>
                                {originalPrice !== totalPrice && originalPrice > 0 ?
                                    (
                                        <span className='origin'>
                                            ${toTwoDecimals(originalPrice)}
                                        </span>
                                    ) : null}
                                {totalPrice > 0 &&
                                    `$${toTwoDecimals(totalPrice)}`}
                            </p>
                        </div>
                        {currentPage === "checkout" ? (
                            <AwareButton
                                className='btn-review btn-atc primary'
                                onClick={() => !updating && handlePlaceOrders()}
                                disabled
                            >
                                {!ordering ? (
                                    "Place Order"
                                ) : (
                                    <>
                                        <Spinner size='sm' className='me-2' />
                                        Ordering
                                    </>
                                )}
                            </AwareButton>
                        ) : (
                            <AwareButton
                                className='btn-review btn-atc primary'
                                onClick={() => handleReviewOrders()}
                            >
                                Review Order
                            </AwareButton>
                        )}
                    </div>
                </div>
            </div>
            {Object.keys(cart).length && cart.products?.length > 0 && (
                <CartExpiredAlertModal
                    show={cartTime <= 0 || cartTimeExpired ? true : false}
                    rebuildCart={handleRebuildCart}
                    handleClose={() => {
                    }}
                />
            )}
            <SuccessModal
                show={showSuccessModal}
                handleClose={() => setShowSuccessModal(false)}
            />
            <OutOfStockProductsModal
                unavailableProducts={unavailableProducts}
                setFindSimilarProductId={setFindSimilarProductId}
                findSimilarProductId={findSimilarProductId}
                setSimilarProducts={setSimilarProducts}
                show={showProductsModal}
                setShowSimilarProductsModal={setShowSimilarProductsModal}
                handleClose={() => setShowProductsModal(false)}
                removeProduct={removeProduct}
            />
            <SimilarProductsModal
                show={showSimilarProductsModal}
                similarProducts={similarProducts}
                findSimilarProductId={findSimilarProductId}
                handleClose={() => setShowSimilarProductsModal(false)}
                handleBack={() => {
                    setShowProductsModal(true);
                    setShowSimilarProductsModal(false);
                }}
                handleDone={(pId) => {
                    setShowProductsModal(true);
                    setShowSimilarProductsModal(false);
                    unavailableProducts.length > 1
                        ? removeProduct(pId)
                        : handleNavigation();
                }}
            />
        </div>
    );
};

export default Cart;
